import { useTranslation } from 'react-i18next'

import { Accordion } from '@/modules/shared/components/accordion/Accordion'
import { TruckIcon } from '@/modules/shared/icons/TruckIcon'
import SideNavLink from '@/modules/shared/layouts/side-navigation/SideNavLink'
import { SideBarItem } from '@/modules/shared/layouts/side-navigation/purchaser-navigation/PurchaserNavigation'
import { Themes } from '@/modules/shared/types/Themes'

interface SuppliersSideBarItemProps extends SideBarItem {
  supplierRoutesMatch: boolean
}

export const SuppliersSideBarItem = ({
  supplierRoutesMatch,
  openAccordionKey,
  changeOpenAccordionKey,
  onCloseDrawer,
  sideBarIndexKey,
}: SuppliersSideBarItemProps) => {
  const { t } = useTranslation()
  return (
    <Accordion
      titlePrefixIcon={<TruckIcon className="size-7" />}
      title={t('general.suppliers', 'Suppliers')}
      activeColor={supplierRoutesMatch ? Themes.Primary : undefined}
      defaultOpen={openAccordionKey === sideBarIndexKey}
      handleTriggerClick={() => changeOpenAccordionKey(sideBarIndexKey)}
      buttonClassName="min-h-11 px-3"
      keepActiveColor
    >
      <SideNavLink
        onCloseDrawer={() => onCloseDrawer()}
        testId="suppliers-navigation"
        sideNavLinkItems={[
          {
            key: t('general.mySuppliers', 'My Suppliers'),
            target: '/my-suppliers',
          },
          {
            key: t('general.supplierDirectory', 'Supplier Directory'),
            target: '/supplier-directory',
          },
        ]}
      />
    </Accordion>
  )
}
